import styled from 'styled-components';

export const ButtonBoxPrimary = styled.button`
  height: 48px;
  padding: 0 32px;
  color: #FFFFFF;
  background-color: #0059BE;
  border: none;
  border-radius: 48px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &:hover:not(:disabled) {
    box-shadow: 0 0 24px rgba(0, 119, 255, 0.5);
  }

  &:active {
    opacity: 0.8;
  }

  &:disabled {
    background-color: #969CA3;
    cursor: not-allowed;
  }
`;

export const ButtonBoxSecondary = styled.button`
  height: 48px;
  padding: 0 32px;
  color: #0059BE;
  background-color: transparent;
  border: 2px solid #0059BE;
  border-radius: 48px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: rgba(0, 119, 255, 0.08);
  }

  &:active {
    background: rgba(0, 119, 255, 0.08);
    opacity: 0.8;
  }

  &:disabled {
    background-color: #969CA3;
    cursor: not-allowed;
  }
`;

ButtonBoxPrimary.displayName = 'ButtonBoxPrimary';
ButtonBoxSecondary.displayName = 'ButtonBoxSecondary';
